module.exports = __webpack_public_path__ + "static/media/ic-my-reservations.044ac0b7.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/ic-my-reservations.svg
// module id = 645
// module chunks = 14